import PropTypes from 'prop-types';

const StateAuth = PropTypes.shape({
  company: PropTypes.shape({
    companyCurrency: PropTypes.array,
    customLogoSrc: PropTypes.string,
    himsIsEnabled: PropTypes.bool,
    id: PropTypes.number,
    name: PropTypes.string,
    service_company_id: PropTypes.string,
    shortName: PropTypes.string,
  }),
  companyApps: PropTypes.array,
  companyBranch: PropTypes.shape({
    id: PropTypes.number,
    isExternal: PropTypes.bool,
    name: PropTypes.string,
    service_company_branch_id: PropTypes.string,
    shortName: PropTypes.string,
  }),
  groups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    code: PropTypes.string,
  })),
  affiliateID: PropTypes.number,
  allowEditUnitDetails: PropTypes.bool,
  allowEditUnitPrice: PropTypes.bool,
  awsUsername: PropTypes.string,
  creditCheckAccess: PropTypes.bool,
  email: PropTypes.string,
  id: PropTypes.number,
  isBranchLeader: PropTypes.bool,
  isBranchLeaderSupervisor: PropTypes.bool,
  isBranchLeaderSupervisorII: PropTypes.bool,
  isDeveloper: PropTypes.bool,
  isMainHeadquarters: PropTypes.bool,
  language: PropTypes.string,
  preferredName: PropTypes.string,
  // sr roles
  isSuperAdmin: PropTypes.bool,
  isAdminBasic: PropTypes.bool,
  isAdminCommunity: PropTypes.bool,
  isHeadquarters: PropTypes.bool,
  isDeveloperSupervisor: PropTypes.bool,
  isDeveloperSalesManager: PropTypes.bool,
  isDeveloperSalesAdmin: PropTypes.bool,
  isExternalAgentLeader: PropTypes.bool,
  isExternalAgencyAdmin: PropTypes.bool,
  isExternalAgent: PropTypes.bool,
  isDeveloperStaff: PropTypes.bool,
  isDeveloperSiteplan: PropTypes.bool,
});

export default StateAuth;



// WEBPACK FOOTER //
// ./src/types/StateAuth.jsx